import { Globals } from '../../globals'
import { ReportService } from '../../Services/ReportService';
import { IReportPDF } from '../../Models/IReportPDF';
import { IReportParameter } from '../../Models/IReportParameter';
import { IReportRequest } from '../../Models/IReportRequest';
import { saveAs } from '../../../../node_modules/file-saver/src/FileSaver';

export class SpinnerBase {

  _reportService: ReportService;
  showSpinner: boolean = false;
  timeStamp: Date;

  constructor(reportService: ReportService) {
    this._reportService = reportService;
  }

  printFormCommon(reportPath: string, reportParamArray: IReportParameter[]) {
    this.printFormCommonOverload(reportPath, reportParamArray, true, true);
  }

  printFormCommonOverload(reportPath: string, reportParamArray: IReportParameter[], addReportPathParameter: boolean, addCommonReportParametersInController: boolean) {
    var prefix: string = "";
    var reportFileName: string;
    try {
      var slashIndex: number = reportPath.lastIndexOf('/');
      var totalLength: number = reportPath.length;

      prefix = reportPath.substring(1, slashIndex);
      reportFileName = reportPath.substring(slashIndex + 1, totalLength);
    }
    catch{
      reportFileName = reportPath;
    }

    this.showSpinner = true;

    if (addReportPathParameter) {
      reportParamArray.push({ parameterName: 'ReportPath', parameterValue: reportFileName });
    }

    let reportRequest = {} as IReportRequest;
    reportRequest.addCommonReportParametersInController = addCommonReportParametersInController;
    reportRequest.prefix = prefix;
    reportRequest.reportFileName = reportFileName;
    reportRequest.reportSpecificParameterArray = reportParamArray;
    try {
      this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
        var binaryString = window.atob(res.base64FileContent);
        var stringLength = binaryString.length;
        var bytes = new Uint8Array(stringLength);
        for (var i = 0; i < stringLength; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
        this.showSpinner = false;
      },
        err => {
          console.error(err);
          this.showSpinner = false;
        }
      );
    }
    catch (err) { alert("Error while attempting to print pdf: " + err.message); }
  }

  scrollToTop() {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 200
    if (pos > 200) {
      window.scrollTo(0, 200);
    }
  }
}
